import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import InputSDataSearch from './dataSearch';
import InputsMainGroups from './maingroups';
import InputsGroups from './groups';
import InputsSubGroups from './subgroups';
import InputsSubProducer from './producer';
import InputsDateFrom from './dateFrom';
import InputsDateTo from './dateTo';

let useStyles = makeStyles((theme) => ({
    root: {
        padding: '20px',
        [theme.breakpoints.down("700")]: {
            width:'100%',
            padding: '5px',
        },
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

    },

    inputs: {
        width:'100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap:'wrap',
        margin:"15px 0px",
        [theme.breakpoints.down("1170")]: {
            width: 850,
            maxWidth :'95%',
            margin:"15px auto",
        },
        [theme.breakpoints.down("700")]: {
            justifyContent: 'center',
        },
    },
    button: {
        backgroundColor: "#E60001",
        color: "white",
        border: 0,
        borderRadius: "8px",
        marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("md")]: {
            width: 120,
            height: 40,
        },
        [theme.breakpoints.down("500")]: {
            width: '98%',
            margin:'auto',
        },
    },
    headTitle:{
        display: 'flex',
        alignItems: 'center',
        justifyContent:'space-between',
        flexWrap:'wrap',
        [theme.breakpoints.down("500")]: {
            width: '100%',
            marginTop:20,
            justifyContent: 'center',
            flexDirection: 'column'
        },
    },
    gridBtn: {
        [theme.breakpoints.down("500")]: {
            width: '100%',
            margin: "10px 0px",
        },
    },
}))

export default function Index({ state, setState, setFlagApi }) {

    let classes = useStyles();

    const handleChange = (value, key) => {
        setState({
            ...state,
            [key]: value,
        });
    };


    return (
        <div className={classes['root']}>

            <div className={classes['headTitle']}>
                <h3>
                    آمار معاملات صادراتی
                </h3>
                <div className={classes['gridBtn']}>
                    <button
                        className={classes['button']}
                        onClick={() => setFlagApi(prev => !prev)}
                    >
                        جستجو
                    </button>
                </div>
            </div>
            <hr />
            <div className={classes['header']}>
                <div className={classes['inputs']}>
                    <InputSDataSearch
                        state={state}
                        handleChange={handleChange} />
                    <InputsMainGroups
                        state={state}
                        handleChange={handleChange} />
                    <InputsGroups
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />
                    <InputsSubGroups
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />
                    <InputsSubProducer
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />
                    <InputsDateFrom
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />
                    <InputsDateTo
                        state={state}
                        setState={setState}
                        handleChange={handleChange} />
                </div>
  
            </div>
            
        </div>)
}
